export const API_URL = process.env.VUE_APP_API_URL;
export const GOFAR_SERVICE_URL = process.env.VUE_APP_GOFAR_SERVICE_URL;

export const HTTP_STATUS_CODES = {
  SUCCESS: 200,
  NO_CONTENT: 204,
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_ERROR: 500,
};

export const HTTP_METHODS = {
  GET: "get",
  POST: "post",
  PUT: "put",
  DELETE: "delete",
};

export const ROLES = {
  ADMIN: 'admin',
  AUTHENTICATED: 'authenticated',
  FLEET_DRIVER: 'fleetDriver',
  FLEET_ADMIN: 'fleetAdmin',
};

export const SUCCESS_HTTP_STATUS_CODES = [
  HTTP_STATUS_CODES.SUCCESS,
  HTTP_STATUS_CODES.NOT_FOUND,
];
